import { language } from '../i18n';

export function formatCo2Value(value: number) {
  const result = value.toLocaleString(language, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  return result;
}
